/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Auth from '../../utils/Auth';
import OwnerLayout from '../layout/owner/OwnerLayout';

export default (props) => (
  <>
    {Auth.isAuthenticated(['owner']) ? (
      <OwnerLayout>
        <Route {...props} />
      </OwnerLayout>
    ) : (
      <Redirect to="/" />
    )}
  </>
);
